import React from 'react';
import * as H1 from '../Helper/H1';
import Send from '../Helper/Send';
import $ from "jquery";
import toast, { Toaster } from 'react-hot-toast';
import OtpInput from 'react-otp-input';
import Countdown, { zeroPad } from 'react-countdown';
import Flickity from 'react-flickity-component'
import { NavLink, useParams, useNavigate } from 'react-router-dom';

import { GoogleLogin } from 'react-google-login';

import {Divider, ButtonGroup, CheckboxGroup, Checkbox, Modal, FlexboxGrid, Schema, Form, Container, Animation, Panel, Button } from 'rsuite';



function withParams(Component) {
    return props => <Component {...props} params={useParams()} navigation={useNavigate()} />;
}


const model_phone = Schema.Model({
    name: Schema.Types.StringType('فقط عدد انگلیسی وارد نمایید.').isRequired('این فیلد الزامی است.').addRule((value, data) => { return H1.is_PhoneNum(value) }, 'شماره موبایل صحیح نمیباشد')
});

const model_register = Schema.Model({
    name: Schema.Types.StringType().isRequired('این فیلد الزامی است.').minLength(7, 'لطفا نام خود را به صورت کامل وارد نمایید').pattern(/[آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ]/, 'نام خود را به فارسی وارد نمایید'),
    email: Schema.Types.StringType().isEmail('ایمیل وارد شده صحیح نمی باشد'),
    age: Schema.Types.NumberType('فقط عدد انگلیسی وارد نمایید.').isRequired('این فیلد الزامی است.').isInteger('فقط عدد انگلیسی وارد نمایید.').min(1, 'سن وارد شده صحیح نمی باشد.').max(99, 'سن وارد شده صحیح نمی باشد.'),
    tall: Schema.Types.NumberType('فقط عدد انگلیسی وارد نمایید.').isRequired('این فیلد الزامی است.').isInteger('فقط عدد انگلیسی وارد نمایید.').min(1, 'قد وارد شده صحیح نمی باشد.').max(300, 'قد وارد شده صحیح نمی باشد.'),
    weight: Schema.Types.NumberType('فقط عدد انگلیسی وارد نمایید.').isRequired('این فیلد الزامی است.').isInteger('فقط عدد انگلیسی وارد نمایید.').min(1, 'وزن وارد شده صحیح نمی باشد.').max(500, 'وزن وارد شده صحیح نمی باشد.'),
    role: Schema.Types.ArrayType('پذیرفتن شرایط و قوانین الزامی میباشد.').isRequired('این فیلد الزامی است.'),

    //password: Schema.Types.StringType().isRequired('این فیلد الزامی است.').minLength(8, 'رمز وارد شده کمتر از 8 کارکتر میباشد'),
});



export class Login extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            step: 1,
            the_phone: null,
            resend_code: false,
            otp: '',
            loader_1: false,
            loader_2: false,
            Countdown_date: null,
            register_info: null,
            google_login: null,
            role_modal: false,
            contact_modal: false,
        };



    }

    componentDidMount() {
      ///  window.gapi.load("client:auth2")
    }




    //------------------ resendTimer-----------------------

    resendTimer = (data) => {

        if (data.completed) {

            this.setState({ resend_code: true });
            return null;
        }
        else {
            return (
                <span>
                    {zeroPad(data.minutes)}:{zeroPad(data.seconds)}
                </span>
            );
        }

    }


    //------------------ resendCode-----------------------


    reset_timer = () => {
        this.setState({ Countdown_date: Date.now() + 120000 });
        this.setState({ resend_code: false });
    }


    resendCode = () => {

        this.reset_timer();

        let data = {
            phone: this.state.the_phone,
            type: 'send_code',
        };
        Send('user/login', data, false).then((res) => {
            H1.notfy_success(res.message)
            this.step_change(3)
        });

    }


    //------------------ handle_otp-----------------------

    handle_otp = (otp) => this.setState({ otp });

    //------------------ step_change-----------------------

    step_change = (id) => {

        this.setState({ loader_1: false });
        this.setState({ step: id });

    }




    //------------------ verify_code-----------------------


    verify_code = (e) => {


        this.setState({ loader_1: true });

        let data = {
            phone: this.state.the_phone,
            code: this.state.otp,
            type: 'verify_code',
        };

        Send('user/login', data, false).then((res) => {

            H1.notfy(res.message)


            if (res.data.type === 'register') {
                this.step_change(4)
            }
            else if (res.data.type === 'login') {

                this.Set_Token(res.data.token);
            }



        }).catch((err) => {
            this.setState({ loader_1: false });
        });


    }



    //------------------ Set Token -----------------------


    Set_Token = (token) => {

        H1.new_token(token);
        window.location.reload();
    }


    //------------------ do_login-----------------------


    do_login = (e) => {


        this.setState({ loader_1: true });

        let data = {
            phone: $("#in_phone").val(),
            type: 'send_code',
        };

        this.setState({ the_phone: data.phone });


        Send('user/login', data, false).then((res) => {
            H1.notfy_success(res.message)

            this.reset_timer();


            this.step_change(3)
        }).catch((err) => {
            this.setState({ loader_1: false });
        });


    }


    //------------------ do_register-----------------------


    do_register = () => {

        this.setState({ loader_1: true });

        let data = this.state.register_info;
        data['number'] = this.state.google_login ? this.state.google_login.googleId : this.state.the_phone;

        if (this.state.google_login) {
            data['avatar'] = this.state.google_login.imageUrl ?? null
        }

        Send('user/register', data, true).then((res) => {
            H1.notfy_success(res.message)
            if (res.data.type === 'login') {
                this.Set_Token(res.data.token);
            }
        }).catch((err) => {
            this.setState({ loader_1: false });
        });


    }




    /* -------------------------------------------------------------------------- */
    /*                                 Show password                              */
    /* -------------------------------------------------------------------------- */
    show_pass = (e) => {


        let pass_id = e.currentTarget.dataset.pass_id;
        let input_type = $(pass_id).attr('type');

        if (input_type === "password") {
            $(pass_id).attr('type', 'text')
            $(".show_pass").children("i").attr("class", "far fa-eye");
        }
        else {
            $(pass_id).attr('type', 'password');
            $(".show_pass").children("i").attr("class", "far fa-eye-slash");
        }


    }


    /* -------------------------------------------------------------------------- */
    /*                                  LoginGoogle                               */
    /* -------------------------------------------------------------------------- */
    Google_login_Error = (e) => {

        H1.notfy_error('مشکل فنی در احراز اطلاعات');

    }

    Google_login_Success = (e) => {




        let data = {
            phone: e.profileObj.googleId,
            type: '',
        };

        Send('user/login', data, false).then((res) => {

            H1.notfy(res.message)


            if (res.data.type === 'register') {

                this.setState({
                    google_login: e.profileObj,
                    register_info: {
                        name: e.profileObj.givenName,
                        email: e.profileObj.email

                    },
                });

                this.step_change(4)
            }
            else if (res.data.type === 'login') {

                this.Set_Token(res.data.token);
            }



        }).catch((err) => {

            this.setState({ loader_2: false });

        });





    }






    // ------------------------- show_error ----------------------------
    show_error = (e) => {
        document.getElementById(Object.keys(e)[0]).scrollIntoView({ behavior: 'smooth' , block: 'center' });
    }



    render() {

        H1.page_name("VActive");



        return (


            // className={`Step: ${step === 0 && 'fade'}`

            <div className="authincation h-100">


                {this.state.step === 1 &&


                    <div className="step_row">
                        <img className='w-100' src="/img/login_intro.png" />
                        <Panel align="middle" className='login_intro w-100 position-absolute bottom-0 start-0 esh-dark p-3'>
                            <b className='fs-4'>وی‌اکتیو</b>



                            <Flickity
                                flickityRef={c => this.flkty = c}
                                className={'carousel mt-2 overflow-hidden login_intro_slide'} // default ''
                                elementType={'div'} // default 'div'
                                options={{
                                    initialIndex: 2,
                                    prevNextButtons: false,
                                    cellAlign: 'center',
                                    rightToLeft: true,

                                    wrapAround: false
                                }} // takes flickity options {}
                                disableImagesLoaded={false} // default false
                                static // default false
                            >


                                <div className='w-100'> فقط انجامش بده</div>
                                <div className='w-100'>به جاش فردا کارهایی رو انجام میدی که بقیه نمی‌تونن</div>
                                <div className='w-100'> امروز کاری رو انجام بده که بقیه دوست ندارن</div>



                            </Flickity>






                            <Animation.Bounce in={true}>
                                <Button appearance="primary" block className='fw-light btn_s1 mt-3' onClick={() => this.step_change(2)} >شروع کنید</Button>
                            </Animation.Bounce>
                        </Panel>
                    </div>
                }


                {this.state.step === 2 &&

                    <Animation.Slide in={true} placement="right" >

                        <div className="step_row">

                            <Container className='p-4'>

                                <div className="text-center mb-5 py-2 position-relative">
                         
                                <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.step_change(1)}></span>

                                    <span className='fs-6'>ورود</span>
                                </div>

                                <Form model={model_phone} checkTrigger='none' noValidate={true} align="middle" onCheck={(e) => H1.isEmpty(e) && this.do_login()}  >


                                    <Form.Group controlId="name" className='px-2'>
                                        <Form.ControlLabel align="right">شماره موبایل</Form.ControlLabel>
                                        <Form.Control id="in_phone" name="name" type="tel" pattern="[0-9]*" inputMode="numeric" className='py-3 ltr in_s1 NumOnly' placeholder='مثال: ۰۹۱۲۳۴۵۶۷۸۹' />
                                    </Form.Group>


                                    <Button appearance="primary" type="submit" block className='fw-light btn_s1 mt-3 mx-auto' loading={this.state.loader_1} >ورود</Button>


                                </Form>


                                <Divider />

                                <Button appearance="ghost" block className='mt-2 mx-auto' style={{ width: '150px' }} onClick={() => this.step_change(22)}>کاربران خارج از کشور</Button>



                                <Divider />


                                <Button appearance="ghost" color="yellow" className='mt-4 mx-auto' style={{ width: '150px' }} onClick={() => this.setState({ role_modal: true })}>قوانین وی‌اکتیو </Button>
                                <Button appearance="ghost" color="yellow" className='mt-2 mx-auto' style={{ width: '150px' }} onClick={() => this.setState({ contact_modal: true })}>درباره وی‌اکتیو </Button>



                            </Container>



                        </div>

                    </Animation.Slide>
                }



                {this.state.step === 22 &&

                    <Animation.Slide in={true} placement="right" >

                        <div className="step_row">

                            <Container className='p-4'>

                                <div className="text-center mb-5 py-2 position-relative">
                      
                                    <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.step_change(2)}></span>
                                    <span className='fs-6'>ورود </span>
                                </div>


                                <p> اگر ساکن خارج از کشور هستید و یا شماره تلفن ایران ندارید از این قسمت استفاده نمایید.</p>
                                {/* 
                                <Button appearance="primary" type="submit" block className='fw-light btn_s1 mt-3 mx-auto' loading={this.state.loader_1} onClick={() => this.LoginGoogle()} > ورود با اکانت گوگل</Button>
 */}

                                <hr />



                                {this.state.loader_2 ?

                                    <Button appearance="subtle" loading>صبر کنید</Button>

                                    :

                                    <GoogleLogin
                                        clientId="452048831682-nhuhk2l659v1nocu96tk4meuks7hgnfn.apps.googleusercontent.com"
                                        buttonText="ورود با اکانت گوگل"
                                        onSuccess={this.Google_login_Success}
                                        onFailure={this.Google_login_Error}
                                        onRequest={() => this.setState({ loader_2: true })}
                                        // onAutoLoadFinished={() =>  this.setState({ loader_2: true }) }
                                        cookiePolicy={'single_host_origin'}
                                        accessType={'offline'}
                                        className='br-16'

                                    />
                                }

                            </Container>

                        </div>

                    </Animation.Slide>
                }




                {this.state.step === 3 &&

                    <Animation.Slide in={true} placement="right" >

                        <div className="step_row">

                            <Container className='p-4'>

                                <div className="text-center mb-5 py-2 position-relative">
                                   
                                    <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.step_change(2)}></span>
                                    <span className='fs-6'>کد ورود</span>
                                </div>

                                <Form align="middle">

                                    <Form.Group controlId="name">
                                        <Form.ControlLabel>کد پیامک شده به شماره  <span className='cc-1'> {this.state.the_phone ?? ''} </span>    را وارد نمایید  </Form.ControlLabel>


                                        <FlexboxGrid justify="center" className='py-2 ltr'>
                                            <OtpInput

                                                containerStyle='text-center'
                                                inputStyle='rs-input opt_in mx-1'
                                                value={this.state.otp}
                                                onChange={this.handle_otp}
                                                numInputs={4}
                                                isInputNum={true}
                                                placeholder="----"
                                            />
                                        </FlexboxGrid>

                                        {this.state.resend_code === false ?

                                            <div className='py-3'>ارسال مجدد کد تا  <Countdown date={this.state.Countdown_date} renderer={this.resendTimer} />   </div>
                                            :
                                            <div className='py-3'><Button appearance="ghost" color='orange' size="xs" onClick={this.resendCode} >  ارسال مجدد </Button>  </div>


                                        }

                                        <Button appearance="primary" type="submit" block className='fw-light btn_s1 mt-3 mx-auto' onClick={this.verify_code} loading={this.state.loader_1} >ادامه</Button>
                                    </Form.Group>

                                    <Button appearance="subtle" className='cc-1' onClick={() => this.step_change(2)} >  اصلاح شماره موبایل  <img src='/img/icon/reload.svg' width={20} className="ms-2" /></Button>

                                </Form>


                            </Container>
                        </div>

                    </Animation.Slide>
                }



                {this.state.step === 4 &&

                    <Animation.Slide in={true} placement="right" >

                        <div className="step_row">

                            <Container className='p-4'>

                                <div className="text-center mb-5 py-2 position-relative">
                       
                                    <span className="icon-Back fs-3 position-absolute top-50 end-0 translate-middle-y" onClick={() => this.step_change(2)}></span>
                                    <span className='fs-6'>تکمیل اطلاعات</span>
                                </div>

                                <Form model={model_register} formDefaultValue={this.state.register_info ?? {}} checkTrigger='none' noValidate={true} align="middle" onChange={(val) => this.setState({ register_info: val })} onCheck={(e) => H1.isEmpty(e) ? this.do_register(): this.show_error(e)} >


                                    <Form.Group controlId="name" className='px-2'>
                                        <Form.ControlLabel align="right">نام کامل</Form.ControlLabel>
                                        <Form.Control id="name" name="name" type="text" className='py-3 in_s1' placeholder='میلاد قیاسی' />
                                    </Form.Group>

                                    <Form.Group controlId="name" className='px-2'>
                                        <Form.ControlLabel align="right"> ایمیل</Form.ControlLabel>
                                        <Form.Control disabled={this.state.google_login ?? false} id="email" name="email" type="email" className='py-3 in_s1' placeholder='example@mail.com' />
                                    </Form.Group>
                                    {/* 
                                    <Form.Group controlId="name" className='px-2'>
                                        <Form.ControlLabel align="right">رمز عبور </Form.ControlLabel>
                                        <Form.Control id="in_r_name" name="password" type="password" className='py-3 in_s1' placeholder='حداقل ۸ کاراکتر' />
                                    </Form.Group> */}


                                    <Form.Group controlId="name" className='px-2'>
                                        <Form.ControlLabel align="right">سن</Form.ControlLabel>
                                        <Form.Control id="age" name="age" type="tel" pattern="[0-9]*" inputMode="numeric" className='py-3 in_s1 NumOnly' placeholder='به سال وارد نمایید' />
                                    </Form.Group>


                                    <Form.Group controlId="name" className='px-2'>
                                        <Form.ControlLabel align="right">قد</Form.ControlLabel>
                                        <Form.Control id="tall" name="tall" type="tel" pattern="[0-9]*" inputMode="numeric" className='py-3 in_s1 NumOnly' placeholder='به سانتی‌متر وارد نمایید' />
                                    </Form.Group>

                                    <Form.Group controlId="name" className='px-2'>
                                        <Form.ControlLabel align="right">وزن</Form.ControlLabel>
                                        <Form.Control id="weight" name="weight" type="tel" pattern="[0-9]*" inputMode="numeric" className='py-3 in_s1 NumOnly' placeholder='به کیلوگرم وارد نمایید' />
                                    </Form.Group>

                                    <Form.Group controlId="role" className='px-2 text-start '>

                                        <Form.Control id='role' name="role" accepter={CheckboxGroup} inline>
                                            <Checkbox value="1">  تمامی  <span className="text-danger" onClick={() => this.setState({ role_modal: true })}>  شریط و قوانین </span>  را خوانده ام و آن ها را می پذیرم.</Checkbox>
                                        </Form.Control>
                                    </Form.Group>


                                    <Button appearance="primary" type="submit" block className='fw-light btn_s1 mt-4 mx-auto' loading={this.state.loader_1}>ثبت‌نام</Button>


                                </Form>



                            </Container>

                        </div>

                    </Animation.Slide>
                }




                <Modal open={this.state.role_modal} >
                    <Modal.Header>
                        <Modal.Title>قوانین وی‌اکتیو</Modal.Title>
                    </Modal.Header>
                    <hr />
                    <Modal.Body>

                        <div className='pe-2'>
                            به وی‌اکتیو خوش آمدید.
                            <br />
                            <br />
                            لطفاً قبل از استفاده از این اپلیکیشن، قوانین و مقررات زیر را با دقت مطالعه کنید. با استفاده از این اپلیکیشن، شما تمامی شرایط و مقررات مندرج در این صفحه را پذیرفته‌اید و متعهد به رعایت آن‌ها می‌باشید. در صورت عدم موافقت با این قوانین، لطفاً از استفاده از این اپلیکیشن خودداری کنید.
                            <br />
                            <br /> <br />
                            ۱. محتوا و حقوق مالکیت معنوی:
                            <br />

                            - هرگونه محتوای منتشر شده در این اپلیکیشن، از جمله متن‌ها، تصاویر، ویدیوها و سایر موارد، تحت حمایت قوانین حقوق مالکیت معنوی قرار دارد.
                            - هرگونه کپی‌برداری یا استفاده غیرمجاز از محتوای این اپلیکیشن ممنوع بوده و ممکن است موجب پیگیری‌های قانونی شود.
                            <br /> <br />
                            ۲. حریم خصوصی:
                            <br />

                            - ما از اطلاعات شخصی شما با هدف ارتقاء و بهبود خدمات استفاده می‌کنیم.
                            - با استفاده از این اپلیکیشن، شما نسبت به جمع‌آوری و استفاده از اطلاعاتتان طبق سیاست حریم خصوصی این اپلیکیشن موافقت می‌کنید.
                            <br /> <br />
                            ۳. تغییرات در قوانین:
                            <br />

                            - ما ممکن است قوانین و مقررات این اپلیکیشن را با اطلاع قبلی تغییر دهیم. شما مسئولیت دارید که قوانین جدید را مطالعه کرده و پذیرفته شده تلقی کنید.

                            لطفاً توجه داشته باشید که این قوانین و مقررات می‌توانند با مسائل قانونی جزئی دیگر همراه باشند. برای اطلاعات بیشتر یا در صورت داشتن هرگونه سوال یا ابهامی، با تیم پشتیبانی اپلیکیشن تماس بگیرید.

                            با استفاده از این اپلیکیشن، شما با تمام شرایط و مقررات گفته شده موافقت نموده‌اید.
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <hr />

                        <Button className='mt-3 mx-auto d-block' onClick={() => this.setState({ role_modal: false })} appearance="primary">
                            متوجه شدم
                        </Button>

                    </Modal.Footer>
                </Modal>



                <Modal open={this.state.contact_modal} >
                    <Modal.Header>
                        <Modal.Title>درباره وی‌اکتیو</Modal.Title>
                    </Modal.Header>
                    <hr />
                    <Modal.Body>

        

                    </Modal.Body>
                    <Modal.Footer>
                        <hr />

                        <Button className='mt-3 mx-auto d-block' onClick={() => this.setState({ contact_modal: false })} appearance="primary">
                           بستن
                        </Button>

                    </Modal.Footer>
                </Modal>




            </div>


        )
    }
}


export default withParams(Login);

